/**
 * Mobile — avoid first-scroll hitches right after load (hero → journey handoff).
 */

export const HERO_EXIT_SCROLL_VH = 0.22;

/** True once the user has scrolled past the hero stack. */
export function isPastHeroScroll(lenis) {
  const vh = window.innerHeight || 800;
  const y = lenis?.scroll ?? window.scrollY ?? 0;
  return y > vh * HERO_EXIT_SCROLL_VH;
}

/** Hero zone — keep Lenis touch path native (no delta cap / gate soften). */
export function isInHeroScrollZone(lenis) {
  return !isPastHeroScroll(lenis);
}

/** Past hero start — allow section snap for sections below the hero. */
export function isPastHeroForSectionSnap(lenis) {
  const hero = document.getElementById("hero");
  const vh = window.innerHeight || 800;
  const y = lenis?.scroll ?? window.scrollY ?? 0;
  if (!hero) return y > vh * HERO_EXIT_SCROLL_VH;
  return y > hero.offsetTop + hero.offsetHeight * 0.28;
}
